<template>
  <div class="import-box">
    <div>
      <p>
        <span>1、题目可以不加题号，题干中间不得换行</span>
      </p>
      <p>
        <span>2、题干与选项，及各选项之间需回车换行，选项需要以ABCD..开头与选项内容用一个字符隔开。比如:A. A、A：等等</span>
      </p>
      <p>
        <span>3、题目答案请务必写在（）括号中，判断题答案请在（）括号内直接写‘是’或‘否’,无需编写选项</span>
      </p>
      <p>
        <span>4、单次导入试题数量不可超过100道</span>
      </p>
      <p>
        设置统一关键字：
        <el-input class="keyword" v-model="keyword" placeholder="请输入关键字"></el-input>
      </p>
    </div>
    <div class="cont-box">
      <el-input type="textarea" v-model="ques" :placeholder="msg"></el-input>
      <el-button type="primary" @click="addQues">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: `1、我国的火警报警电话是（C）？
A、110
B、120
C、119
D、911
2、四大文明古国中的，四大文明是下列选项中的哪四个（ABCE）？
A、埃及文明
B、印度文明
C、中国文明
D、希腊文明
E、美索不达米亚文明
1、1+1是否等于2（是）？
`,
      ques: "",
      arrCode: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      questions: "",
      keyword: ""
    };
  },
  props: ["paper_id"],
  created() {
    this.init();
  },
  methods: {
    init() {},
    addQues() {
      let arr = [];
      let ques = [];
      arr = this.ques.split("\n");

      let obj = {
        //一道题所包含的属性
        name: "",
        type: 0,
        parsing: "", //答案解析
        difficulty: "A",
        keyword: this.keyword,
        chapter_id: [],
        is_insert: true,
        is_right: null,
        options: []
      };
      for (var i = 0; i < arr.length; i++) {
        if (/[\(（)][A-Za-z\u662f\u5426]*[\)）]/.test(arr[i])) {
          //判断是否有括号并且括号内是A-Z的大写字母
          if (obj.name) {
            // 丢进题目列表中

            //对题目的is_right做处理
            if (obj.type == 1) {
              let str = obj.is_right;
              obj.is_right = this.arrCode.indexOf(str);
            } else if (obj.type == 2) {
              // obj.is_right=[];
              let a = [];
              let b = JSON.parse(JSON.stringify(obj.is_right));
              this.arrCode.forEach((item, index) => {
                if (b.indexOf(item) != -1) {
                  a.push(index);
                }
              });
              obj.is_right = a;
            }
            ques.push(obj);
            // 清空
            obj = {
              name: "",
              type: 0,
              parsing: "", //答案解析
              difficulty: "A",
              keyword: this.keyword,
              chapter_id: [],
              is_insert: true,
              is_right: null,
              options: []
            };
          }
          obj.name =
            "<p>" +
            arr[i]
              .replace(/[\(（)][A-Za-z\u662f\u5426]*[\)）]/, "（）")
              .replace(/^[0-9]{0,}[.:、：]{1,}/g, "") +
            "</p>";

          let right = arr[i].match(/[\(（)][A-Za-z\u662f\u5426]*[\)）]/)[0];
          right = right.slice(1, right.length - 1);

          // 判断题目类型以及题目的is_right
          if (right.length == 0) {
            alert("题目输入错误！！！");
          } else if (right.length > 1) {
            obj.type = 2;
            obj.is_right = right.split("");
          } else if (right === "是" || right === "否") {
            obj.type = 3;
            obj.options = [
              {
                name: "是",
                brief: "",
                is_right: false
              },
              {
                name: "否",
                brief: "",
                is_right: false
              }
            ];
            obj.is_right = right == "是" ? 0 : 1;
            if (!obj.is_right) {
              obj.options[0].is_right = true;
            } else {
              obj.options[1].is_right = true;
            }
          } else {
            obj.type = 1;
            obj.is_right = right;
          }
        } else {
          // 对选项的拆分
          if (/^[A-Za-z]/.test(arr[i])) {
            let option_name = arr[i].split(arr[i].match(/^[A-Za-z]./)[0])[1];
            let option_right = arr[i].match(/^[A-Za-z]/)[0];
            let is_right = false;

            if (obj.type == 1 && obj.is_right == option_right) {
              is_right = true;
            }
            if (obj.type == 2 && obj.is_right.indexOf(option_right) != -1) {
              is_right = true;
            }
            obj.options.push({
              name: option_name,
              brief: "",
              is_right: is_right
            });
          }
        }
      }
      ques.push(obj);
      this.questions = JSON.stringify(ques);
      if (ques.length > 100) {
        this.$message.warning("请控制题目在100道以内");
      } else {
        this.submit();
      }
    },
    submit() {
      let _this = this;
      this.$http
        .post(process.env.VUE_APP_ADMIN_URL + "questionImports", {
          paper_id: this.paper_id,
          data: this.questions
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.$message.success("导入成功");
            _this.ques = "";
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.searchBox {
  margin: 10px auto;
  padding: 0 5px;
}
.madepaper {
  text-align: center;
}
.pages {
  padding: 10px;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    sdisplay: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}
img {
  width: 100px;
}
/deep/.el-textarea .el-textarea__inner {
  height: 400px;
}
.cont-box {
  text-align: center;
}
.cont-box .el-button {
  margin: 10px auto;
  width: 150px;
}
.keyword {
  width: 300px;
}
</style>
